import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from '../../components/Sidebar';
import ProfileDropdown from '../../components/ProfileDropdown';
import API_BASE from '../../utils/api';

const ParentTimetable = () => {
  const [timetable, setTimetable] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTimetable = async () => {
      try {
        const res = await axios.get(`${API_BASE}/timetable/my-child`);
        setTimetable(res.data);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    };
    fetchTimetable();
  }, []);

  const formatDate = (d) => new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 lg:ml-64">
        <header className="bg-white shadow-sm border-b px-6 py-4 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">📅 Class Timetable</h1>
            <p className="text-sm text-gray-500">Your child's weekly class schedule</p>
          </div>
          <ProfileDropdown />
        </header>

        <main className="p-6">
          {loading ? <p className="text-gray-500">Loading timetable...</p> : !timetable ? (
            <div className="bg-white rounded-xl shadow p-10 text-center">
              <div className="text-5xl mb-4">📅</div>
              <h3 className="text-lg font-semibold text-gray-700">No Timetable Available</h3>
              <p className="text-gray-500">The principal has not yet assigned a timetable for your child's class.</p>
            </div>
          ) : (
            <div>
              <div className="bg-white rounded-xl shadow-sm border p-5 mb-6">
                <div className="flex flex-wrap justify-between items-center">
                  <div>
                    <h3 className="font-bold text-lg text-indigo-800">
                      {timetable.classId?.className} - {timetable.classId?.section}
                    </h3>
                    <p className="text-sm text-gray-500">
                      📆 {formatDate(timetable.weekStartDate)} — {formatDate(timetable.weekEndDate)} | AY: {timetable.academicYear}
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                {timetable.schedule.map(daySchedule => (
                  <div key={daySchedule.day} className="bg-white rounded-xl shadow-sm border overflow-hidden">
                    <div className="bg-gradient-to-r from-indigo-500 to-blue-500 px-5 py-3">
                      <h4 className="font-bold text-white">{daySchedule.day}</h4>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead className="bg-gray-50">
                          <tr>
                            <th className="px-4 py-3 text-left font-semibold text-gray-600">Period</th>
                            <th className="px-4 py-3 text-left font-semibold text-gray-600">Subject</th>
                            <th className="px-4 py-3 text-left font-semibold text-gray-600">Teacher</th>
                            <th className="px-4 py-3 text-left font-semibold text-gray-600">Time</th>
                            <th className="px-4 py-3 text-left font-semibold text-gray-600">Room</th>
                          </tr>
                        </thead>
                        <tbody>
                          {daySchedule.periods.map((p, i) => (
                            <tr key={i} className={`border-t ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                              <td className="px-4 py-3">
                                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-indigo-100 text-indigo-700 font-bold text-xs">
                                  {p.periodNumber}
                                </span>
                              </td>
                              <td className="px-4 py-3 font-semibold text-gray-800">{p.subject || '-'}</td>
                              <td className="px-4 py-3 text-gray-600">{p.teacherName || '-'}</td>
                              <td className="px-4 py-3 text-gray-600 whitespace-nowrap">{p.startTime} - {p.endTime}</td>
                              <td className="px-4 py-3 text-gray-600">{p.room || '-'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default ParentTimetable;
